<template>
  <ClientOnly>
    <UModal title="Recuperar Senha" v-model:open="uiStore.isForgotModalOpen" close-icon="ph:x" data-cy="forgot-password-modal"
            :ui="{title: 'text-xl', overlay: 'bg-black/85'}">

      <template #body>
        <p class="mb-4 text-sm text-gray-600 dark:text-gray-400">
          Para redefinir sua senha, preencha seu usuário ou seu e-mail abaixo. Se sua conta for encontrada no banco de dados, um e-mail será enviado para seu endereço de e-mail, com as instruções sobre como restabelecer seu acesso.
        </p>

        <form action="/login/forgot_password.php" method="POST" class="flex flex-col gap-6" data-cy="forgot-password-form">
          <input type="hidden" name="sesskey" :value="uiStore.sesskey" />
          <input type="hidden" name="_qf__login_forgot_password_form" value="1" />

          <div class="p-4 border rounded-md dark:border-gray-700">
            <h4 class="mb-2 font-semibold">Buscar por identificação de usuário</h4>
            <UFormField label="Identificação de usuário" name="username">
              <UInput name="username" placeholder="Digite seu usuário" class="w-full" data-cy="forgot-username-input" />
            </UFormField>
            <div class="mt-3 flex justify-end">
              <UButton type="submit" name="submitbuttonusername" value="Buscar" color="primary" data-cy="forgot-username-submit">
                Buscar por Usuário
              </UButton>
            </div>
          </div>

          <div class="flex items-center justify-center">
            <span class="text-sm text-gray-500">OU</span>
          </div>

          <div class="p-4 border rounded-md dark:border-gray-700">
            <h4 class="mb-2 font-semibold">Buscar pelo endereço de e-mail</h4>
            <UFormField label="Endereço de e-mail" name="email">
              <UInput name="email" type="email" placeholder="Digite seu e-mail" class="w-full" data-cy="forgot-email-input" />
            </UFormField>
            <div class="mt-3 flex justify-end">
              <UButton type="submit" name="submitbuttonemail" value="Buscar" color="primary" data-cy="forgot-email-submit">
                Buscar por E-mail
              </UButton>
            </div>
          </div>
          <UButton variant="link" class="p-1 underline ml-auto cursor-pointer"
                   @click="uiStore.openAuthModal(); uiStore.closeForgotModal()" data-cy="return-to-login-button">Lembrou a senha?</UButton>
        </form>
      </template>
    </UModal>
  </ClientOnly>
</template>
<script setup lang="ts">
import { useUiStore } from '~/stores/useUiStore'
import { watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const uiStore = useUiStore()
const route = useRoute()
const router = useRouter()

// Limpar o hash quando o modal for fechado
watch(() => uiStore.isForgotModalOpen, (isOpen) => {
  if (!isOpen && route.hash === '#forgot_password') {
    router.replace({ hash: '' })
  }
})
</script>